export default __webpack_public_path__ + "static/media/default_avatar.a0d2f34f.svg";